import axios from 'axios'

const API_URL = '/api/bowties/'

// Get single bowtie (for editor)
const getBowtie = async (bowtieId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    const response = await axios.get(API_URL + bowtieId, config)
    return response.data
}

// Create bowtie (for editor)
const createBowtie = async (bowtieData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    const response = await axios.post(API_URL, bowtieData, config)
    return response.data
}

// Update bowtie
const updateBowtie = async (bowtieData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    const response = await axios.put(API_URL + bowtieData._id, bowtieData, config)
    return response.data
}

// Delete bowtie
const deleteBowtie = async (bowtieId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    const response = await axios.delete(API_URL + bowtieId, config)
    return response.data
}

// Set viewable flag
const setViewable = async (bowtieId, viewable, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    const response = await axios.patch(API_URL + bowtieId + '/viewable', { viewable }, config)
    return response.data
}

const bowtieService = {
    getBowtie,
    createBowtie,
    updateBowtie,
    deleteBowtie,
    setViewable
}

export default bowtieService